/**
 * Nav-state efêmero para abrir um plano específico no `/planos` (GUPM-213) — canal
 * via router state (não query string, não `/planos/:id`: privacidade + ADR-0019),
 * mesmo padrão do `openTarpNavState`/`readOpenTarpId` do M3 (src/domain/tarp/disparo.ts).
 * Usado quando a baixa da TARP cria/vincula um plano e navega direto a ele.
 *
 */

/** Escreve o nav-state que o `/planos` lê no mount para focar o plano `id`. */
export function openPlanoNavState(id: string): { planoOpenId: string } {
  return { planoOpenId: id };
}

/**
 * Lê o id do plano a focar do nav-state, com narrowing (não cast cego, frontend.md #1):
 * devolve o id só quando é string não-vazia; senão `null` (defesa contra state stale).
 */
export function readOpenPlanoId(state: unknown): string | null {
  if (!state || typeof state !== 'object') return null;
  const id = (state as { planoOpenId?: unknown }).planoOpenId;
  return typeof id === 'string' && id.length > 0 ? id : null;
}
